<script>
export default {
  name: 'TabList',

  props: {
    className: {
      type: String,
      default: 'c-tabs__list'
    },
    id: {
      type: Number,
      default: null
    },
    selected: {
      type: Boolean,
      default: false
    },
    isCondensed: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onClick (index) {
      this.setSelected(index)
    }
  },

  inject: ['currentTabIndex', 'setSelected'],

  render (createElement) {
    const currentTabIndex = this.currentTabIndex()

    return createElement('ul', { class: this.className, attrs: this.$attrs }, [
      this.$scopedSlots.default().filter(item => item.isComment === false).map((slot, index) => {
        return slot.tag.includes('Tab') ? this.$cloneNode(slot, { props: { index, selected: index === currentTabIndex }, on: { click: this.onClick } }) : slot
      })
    ])
  }
}
</script>
